import styled from "styled-components";
import {colorPalette} from "../styles/colorPalette";

export const VerticalLine = styled.div`
	height: 32px;
	border: 1px solid ${colorPalette.primary.c500Primary};
`;
